module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/essentials/sorority-essentials-01-large-6c88cf21231bbe6d97a8893eb0819303.jpg";